import { Inject, Injectable } from '@angular/core';
import { appConfig } from 'src/app/app.config';
import { LoginModel } from 'src/app/Models/login.model';
import { ResourceService } from '../resource/resource.service';
// import { ssrWindow } from 'ssr-window';
import { ConfigService } from '../config.service';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  sendURL: any;
  constructor(
    public resourceService: ResourceService,
    private _ConfigService: ConfigService,
    @Inject(DOCUMENT) private _Document: Document,
  ) {
    // this.sendURL = `https://testdev1.nowcast.cc/`;
    // this.sendURL = 'https://uectv.com/';
    // this.sendURL = "https://pushplayvip.nowcast.cc/"
    // this.sendURL = 'https://testdev1.nowcast.cc/';
    // this.sendURL = "https://prodtesting.nowcast.cc/"
    // this.sendURL = `${window.location.origin}/`;
    this.sendURL = `${this._Document.location.origin}/`;
  }

  loginUser(formData: LoginModel) {
    const loginUrl = this.sendURL + appConfig.logIn;
    return this.resourceService.postData(loginUrl, formData);
  }

  logOutUser() {
    const logOutUrl = this.sendURL + appConfig.logOut;
    return this.resourceService.getData(logOutUrl);
  }

  forgotPassword(data: any) {
    const loginUrl = this.sendURL + `${appConfig.user}/forgetPasswordLink`;
    return this.resourceService.postData(loginUrl, data);
  }

  /**
   * Dashboard reset flow: POST `admin-service/api/v1/user/forgetPassword?id={userId}`
   * with JSON `{ password, confirmPassword, token }`.
   */
  completePasswordReset(body: { userId: string; token: string; password: string; confirmPassword: string }) {
    const id = encodeURIComponent(body.userId.trim());
    // https://dev.nowcast.cc/admin-service/api/v1/user/forgetPassword?id=7610%27
    const url = `${environment.dashboard}${appConfig.userAdmin}/forgetPassword?id=${id}`;
    return this.resourceService.postData(url, {
      password: body.password,
      confirmPassword: body.confirmPassword,
      token: body.token.trim(),
    });
  }
}
